export default __webpack_public_path__ + "static/media/os5.404f7ef6.png";